import { render } from "./DelModal.vue?vue&type=template&id=28428630"
import script from "./DelModal.vue?vue&type=script&lang=js"
export * from "./DelModal.vue?vue&type=script&lang=js"

import "./DelModal.vue?vue&type=style&index=0&id=28428630&lang=css"
script.render = render

export default script